import 'bootstrap-datepicker'
import 'bootstrap-datepicker/js/locales/bootstrap-datepicker.de.js'

up.compiler('[month-picker]', (element, customizations) => {
  const $element = $(element)

  let defaultOptions = {
    format: {
      toDisplay: function (date, format, language) {
        if (date === null || date === undefined) {
          return ''
        }
        const d = new Date(date)
        return `${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`
      },
      toValue: function (date, format, language) {
        const string = date
        if (!/^\d{2}\/\d{4}$/.test(string)) {
          return null
        }
        const [month, year] = string.split('/').map(Number);
        if (month < 1 || month > 12) {
          return null
        }
        return new Date(year, month - 1, 1)
      }
    },
    immediateUpdates: true,
    language: 'de',
    autoclose: true,
    keyboardNavigation: false,
    minViewMode: 'months',
    maxViewMode: 'years',
    startView: 'years',
    startDate: '01/1900',
    endDate: '12/2050',
    templates: {
      leftArrow: '<button type="button" class="datepicker--previous btn btn-sm btn-outline-primary float-left"><i class="fa fa-caret-left"></i></button>',
      rightArrow: '<button type="button" class="datepicker--next btn btn-sm btn-outline-primary float-right"><i class="fa fa-caret-right"></i></button>'
    }
  }
  let options = Object.assign({}, defaultOptions, customizations)

  let onChange = () => $element.trigger('month-picker:change', { value: $element.datepicker('getDate') })
  let destructor = () => $element.datepicker('destroy')

  $element
    .datepicker(options)
    .enableNativeEvent('change')
    .on('hide', onChange)

  return destructor
})
